import request from '@/utils/request'
const BASE_URL = '/GoodsInfo'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  attrList(data) {
    return request({
      url: BASE_URL + '/AttrList',
      method: 'post',
      data
    })
  },
  courseList(data) {
    return request({
      url: BASE_URL + '/CourseList',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  mallGoodsSave(data) {
    return request({
      url: BASE_URL + '/MallGoodsSave',
      method: 'post',
      data
    })
  },
  updateSaleState(data) {
    return request({
      url: BASE_URL + '/UpdateSaleState',
      method: 'post',
      data
    })
  },
  updateRecommendState(data) {
    return request({
      url: BASE_URL + '/UpdateRecommendState',
      method: 'post',
      data
    })
  },
  updateHotState(data) {
    return request({
      url: BASE_URL + '/UpdateHotState',
      method: 'post',
      data
    })
  },
  updateNewState(data) {
    return request({
      url: BASE_URL + '/UpdateNewState',
      method: 'post',
      data
    })
  },
  updateBatchGoods(data) {
    return request({
      url: BASE_URL + '/UpdateBatchGoods',
      method: 'post',
      data
    })
  },
  updateType(data) {
    return request({
      url: BASE_URL + '/UpdateType',
      method: 'post',
      data
    })
  },

  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  getMaxOrderId() {
    return request({
      url: BASE_URL + '/GetMaxOrderId',
      method: 'get',
    })
  },
  getGoodsId() {
    return request({
      url: BASE_URL + '/GetGoodsId',
      method: 'get',
    })
  },
  import: "/api" + BASE_URL + "/Import",
  importab: "/api" + BASE_URL + "/Importab",
  importup: "/api" + BASE_URL + "/Importup",
  importupab: "/api" + BASE_URL + "/Importupab",
  importimg: "/api" + BASE_URL + "/Importimg",
}